// Gecombineerd Universal Bundle Selector Script
// Inclusief: bundle selector, vault-active, scroll, populaire labels, preorder labels, uitverkocht filter
(function () {
  let detectedProductCount = 0;
  
  // Array met ID's van populaire geuren
  const populaireGeuren = [
    '102', '106', '110', '119', '121', '134',
    '202', '203', '207', '214', '226', '232', '234',
    '302', '306', '308', '311', '312', '322', '325', '333', '336'
  ];

  // Array met ID's van preorder geuren
  const preorderGeuren = ['317',];
  
  // Detecteer automatisch hoeveel producten er zijn
  function detectProductCount() {
    const productSelects = document.querySelectorAll('#simple-bundles-io-options select[id^="product-"]');
    detectedProductCount = productSelects.length;
    logDebug(`Gedetecteerd aantal producten: ${detectedProductCount}`);
    return detectedProductCount;
  }

  // Verwijder uitverkochte opties uit alle selects
  function removeOutOfStockOptions() {
    const selects = document.querySelectorAll("#simple-bundles-io-options select");
    selects.forEach(select => {
      const options = select.querySelectorAll("option");
      options.forEach(option => {
        if (option.dataset.inventory === "0") {
          option.remove();
        }
      });
    });
    logDebug('Uitverkochte opties verwijderd uit selects');
  }

  // HTML injectie - dynamisch gebaseerd op aantal producten
  function injectHTML() {
    const productCount = detectProductCount();
    
    if (productCount === 0) {
      logDebug('Geen producten gevonden, HTML injectie overgeslagen');
      return;
    }
    
    let bundleHTML = '<div class="bundle-container vault-active">';
    
    // Genereer dynamisch de fragrance-select divs
    for (let i = 1; i <= productCount; i++) {
      bundleHTML += `<div id="fragrance${i}" class="fragrance-select"></div>`;
    }
    
    bundleHTML += '</div>';

    logDebug(`HTML gegenereerd voor ${productCount} producten met vault-active class`);

    var target = document.querySelector('[data-block-id*="simple_bundles_kits_infinite_options_selector"]');
    if (target) {
      var targetElement = target.querySelector('#simple-bundles-io-options');
      if (targetElement) {
        targetElement.insertAdjacentHTML('beforebegin', bundleHTML);
        targetElement.style.display = 'unset';
      } else {
        target.insertAdjacentHTML('afterbegin', bundleHTML);
      }
    }
  }

  // Dynamische standaard selecties gebaseerd op aantal producten
  function getDefaultSelections(productCount) {
    const baseSelections = {
      3: ['110', '202', '311'],
      6: ['110', '106', '121', '203', '202', '214'],
      9: ['101', '106', '110', '202', '203', '214', '301', '306', '311']
    };
    
    if (baseSelections[productCount]) {
      return baseSelections[productCount];
    }
    
    const selections = [];
    const patterns = ['101', '202', '306', '104', '205', '317', '107', '226', '309', '110', '230', '320'];
    
    for (let i = 0; i < productCount; i++) {
      selections.push(patterns[i % patterns.length]);
    }
    
    logDebug(`Gegenereerde standaard selecties voor ${productCount} producten:`, selections);
    return selections;
  }

  function logDebug(message, data) {
    console.log(`%c[Bundle Debug] ${message}`, 'background:#f0f0f0;color:#333', data || '');
  }

  function triggerChange(element) {
    logDebug(`Trigger change op element:`, element.id);
    const event = new Event('change', { bubbles: true });
    element.dispatchEvent(event);
    element.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function getCorrectProductId(index) {
    return `product-${index + 1}`;
  }

  function initializeSelects() {
    const selects = document.querySelectorAll('#simple-bundles-io-options select');
    const productCount = selects.length;
    const defaultSelection = getDefaultSelections(productCount);
    
    logDebug(`Initializing ${productCount} selects met standaard selecties:`, defaultSelection);

    selects.forEach((select, i) => {
      logDebug(`Select ${i + 1} ID: ${select.id}`);
    });

    selects.forEach(select => {
      Array.from(select.options).forEach(option => {
        option.removeAttribute('selected');
      });
    });

    selects.forEach((select, index) => {
      const preferredValue = defaultSelection[index] || defaultSelection[0];
      logDebug(`Selectie ${index + 1}: zoek naar waarde startend met ${preferredValue} in ${select.id}`);

      const preferredOption = Array.from(select.options).find(option =>
        option.value.startsWith(preferredValue) &&
        !option.disabled &&
        parseInt(option.dataset.inventory) > 0 &&
        !option.value.toLowerCase().includes('5ml sample')
      );

      if (preferredOption) {
        logDebug(`Gevonden voorkeursoptie voor select ${index + 1}:`, preferredOption.value);
        select.value = preferredOption.value;
        preferredOption.selected = true;
        select.selectedIndex = preferredOption.index;
        triggerChange(select);
        return;
      } else {
        logDebug(`Geen voorkeursoptie gevonden voor select ${index + 1}`);
      }

      const availableOption = Array.from(select.options)
        .find(option =>
          !option.disabled &&
          parseInt(option.dataset.inventory) > 0 &&
          option.value &&
          !option.value.toLowerCase().includes('5ml sample')
        );

      if (availableOption) {
        logDebug(`Fallback naar beschikbare optie voor select ${index + 1}:`, availableOption.value);
        select.value = availableOption.value;
        availableOption.selected = true;
        select.selectedIndex = availableOption.index;
        triggerChange(select);
      } else {
        logDebug(`Geen beschikbare optie gevonden voor select ${index + 1}`);
      }
    });

    setTimeout(() => {
      selects.forEach((select, index) => {
        logDebug(`Verificatie voor select ${index + 1}, huidige waarde:`, select.value);

        const preferredValue = defaultSelection[index] || defaultSelection[0];
        if (!select.value || !select.value.startsWith(preferredValue)) {
          logDebug(`Selectie voor index ${index} is niet correct toegepast. Huidige waarde: ${select.value}`);

          const preferredOption = Array.from(select.options).find(option =>
            option.value.startsWith(preferredValue) &&
            !option.disabled &&
            parseInt(option.dataset.inventory) > 0 &&
            !option.value.toLowerCase().includes('5ml sample')
          );

          if (preferredOption) {
            logDebug(`Nieuw poging met optie:`, preferredOption.value);
            select.value = preferredOption.value;
            preferredOption.selected = true;
            select.selectedIndex = preferredOption.index;
            triggerChange(select);
          }
        }
      });
    }, 100);
  }

  function waitForElement(selector) {
    return new Promise(function (resolve) {
      if (!document.body) {
        logDebug('document.body is nog niet beschikbaar, wacht op DOMContentLoaded');
        document.addEventListener('DOMContentLoaded', function() {
          waitForElement(selector).then(resolve);
        });
        return;
      }
      
      if (document.querySelector(selector)) {
        logDebug(`Element direct gevonden: ${selector}`);
        return resolve(document.querySelector(selector));
      }

      logDebug(`Wachten op element: ${selector}`);
      var observer = new MutationObserver(function () {
        if (document.querySelector(selector)) {
          logDebug(`Element gevonden via observer: ${selector}`);
          observer.disconnect();
          resolve(document.querySelector(selector));
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  function parseFragrances() {
    var fragrances = [];
    var options = document.querySelectorAll('#product-1 option');

    options.forEach(function (option) {
      if (option.value && !option.value.toLowerCase().includes('5ml sample')) {
        var id = parseInt(option.value.split(' ')[0]);
        var type = 'UNISEX';

        if (id >= 100 && id < 200) type = 'MEN';
        if (id >= 200 && id < 300) type = 'WOMEN';
        if (id >= 300) type = 'UNISEX';

        const fragranceId = option.value.split(' ')[0];
        const isBestSeller = populaireGeuren.includes(fragranceId);
        const isPreorder = preorderGeuren.includes(fragranceId);

        fragrances.push({
          id: option.value,
          name: option.textContent.trim(),
          type: type,
          inventory: option.disabled ? 0 : (parseInt(option.dataset.inventory) || 0),
          isBestSeller: isBestSeller,
          isPreorder: isPreorder
        });
      }
    });

    logDebug(`Parsed ${fragrances.length} fragrances, waarvan ${fragrances.filter(f => f.isBestSeller).length} populair en ${fragrances.filter(f => f.isPreorder).length} preorder`);
    window.parsedFragrances = fragrances;
    return fragrances;
  }

  var selectedFragrances = [];

  function createFragranceSelector(containerId, index) {
    var container = document.getElementById(containerId);
    if (!container) {
      logDebug(`Container niet gevonden: ${containerId}`);
      return;
    }

    var fragrances = window.parsedFragrances || [];
    if (fragrances.length === 0) {
      logDebug('Geen geuren beschikbaar');
      return;
    }

    var activeFilter = 'ALL';

    var button = document.createElement('button');
    button.className = 'select-button';

    const correctSelectId = getCorrectProductId(index);
    logDebug(`Correct select ID voor index ${index}: ${correctSelectId}`);

    var initialSelect = document.getElementById(correctSelectId);
    var initialValue = initialSelect ? initialSelect.value : '';
    var initialFragrance = fragrances.find(f => f.id === initialValue);
    let index1 = index + 1;

    if (initialFragrance) {
      const selectEl = document.querySelector(`[data-frag="Product ${index1}"]`);

      if (selectEl) {
        const valueToSet = initialFragrance.name;
        const optionExists = Array.from(selectEl.options).some(
          option => option.value === valueToSet
        );

        if (optionExists) {
          selectEl.value = valueToSet;
        }
      }
    }

    logDebug(`Initiele waarde voor ${containerId}: ${initialValue}`);

    button.innerHTML =
      '<span>' +
      (initialFragrance ? initialFragrance.name : 'Selecteer een geur') +
      (initialFragrance && initialFragrance.isBestSeller ? '<span class="best-seller">Populair</span>' : '') +
      (initialFragrance && initialFragrance.isPreorder ? '<span class="preorder">Preorder</span>' : '') +
      '</span>' +
      '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.64245 9.99395 7.35753 9.99395 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path>' +
      '</svg>';

    var dropdown = document.createElement('div');
    dropdown.className = 'dropdown';

    var filterButtons = document.createElement('div');
    filterButtons.className = 'filter-buttonss';
    filterButtons.innerHTML =
      '<button class="filter-btn active" data-type="ALL">ALLES</button>' +
      '<button class="filter-btn" data-type="MEN">HEREN</button>' +
      '<button class="filter-btn" data-type="WOMEN">DAMES</button>' +
      '<button class="filter-btn" data-type="UNISEX">UNISEX</button>';

    var dropdownItems = document.createElement('div');
    dropdownItems.className = 'dropdown-items';
    dropdown.appendChild(filterButtons);
    dropdown.appendChild(dropdownItems);

    function updateDropdownItems() {
      dropdownItems.innerHTML = '';

      var filteredFragrances = activeFilter === 'ALL'
        ? fragrances
        : fragrances.filter(function (f) {
            return f.type === activeFilter;
          });

      filteredFragrances.forEach(function (fragrance) {
        var item = document.createElement('div');
        item.className = 'dropdown-item';

        var stockInfo = '';
        if (fragrance.inventory <= 0) {
          stockInfo = '<span class="out-of-stock">Uitverkocht</span>';
          item.classList.add('disabled');
        } else if (fragrance.inventory < 10) {
          stockInfo = '<span class="low-stock">Nog ' + fragrance.inventory + ' op voorraad</span>';
        }

        item.innerHTML =
          '<div>' +
          fragrance.name +
          (fragrance.isBestSeller ? '<span class="best-seller">Populair</span>' : '') +
          (fragrance.isPreorder ? '<span class="preorder">Preorder</span>' : '') +
          stockInfo +
          '</div>';

        if (fragrance.inventory > 0) {
          item.onclick = function () {
            while (selectedFragrances.length <= index) {
              selectedFragrances.push(null);
            }

            selectedFragrances[index] = fragrance;
            
            button.innerHTML =
              '<span>' +
              fragrance.name +
              (fragrance.isBestSeller ? '<span class="best-seller">Populair</span>' : '') +
              (fragrance.isPreorder ? '<span class="preorder">Preorder</span>' : '') +
              '</span>' +
              '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.64245 9.99395 7.35753 9.99395 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path>' +
              '</svg>';

            const selectId = getCorrectProductId(index);
            logDebug(`Selectie maken voor index ${index} met select ID: ${selectId}`);

            var shopifySelect = document.getElementById(selectId);
            if (shopifySelect) {
              logDebug('Debug - Voor selectie:', {
                selectieNummer: index + 1,
                geurNaam: fragrance.name,
                oudeWaarde: shopifySelect.value,
                nieuweWaarde: fragrance.id
              });

              Array.from(shopifySelect.options).forEach(function (opt) {
                opt.removeAttribute('selected');
              });

              var selectedOption = Array.from(shopifySelect.options).find(function (opt) {
                return opt.value === fragrance.id;
              });

              if (selectedOption) {
                selectedOption.selected = true;
                shopifySelect.selectedIndex = selectedOption.index;
                shopifySelect.value = fragrance.id;
                triggerChange(shopifySelect);

                logDebug(`Optie geselecteerd: ${selectedOption.value}`);
              } else {
                logDebug(`Geen overeenkomende optie gevonden voor ${fragrance.id} in ${selectId}`);
              }

              setTimeout(function () {
                for (let i = 0; i < detectedProductCount; i++) {
                  const productId = getCorrectProductId(i);
                  const element = document.getElementById(productId);
                  logDebug(`Product ${i + 1}: ${element ? element.value : 'niet gevonden'}`);
                }
              }, 500);
            } else {
              logDebug(`FOUT: Geen Shopify select gevonden met ID: ${selectId}`);
            }

            dropdown.classList.remove('active');
          };
        } else {
          item.classList.add('disabled');
        }

        dropdownItems.appendChild(item);
      });
    }

    filterButtons.querySelectorAll('.filter-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        filterButtons.querySelectorAll('.filter-btn').forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');
        activeFilter = btn.dataset.type;
        updateDropdownItems();
      });
    });

    button.onclick = function (e) {
      e.preventDefault();
      e.stopPropagation();

      document.querySelectorAll('.dropdown').forEach(function (otherDropdown) {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('active');
        }
      });

      dropdown.classList.toggle('active');
      updateDropdownItems();
    };

    container.appendChild(button);
    container.appendChild(dropdown);
  }

  function createSelectors() {
    const productCount = detectedProductCount || detectProductCount();
    logDebug(`Creëren van geur selectoren voor ${productCount} producten`);
    
    for (let i = 0; i < productCount; i++) {
      createFragranceSelector(`fragrance${i + 1}`, i);
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.fragrance-select')) {
        document.querySelectorAll('.dropdown').forEach(function (dropdown) {
          dropdown.classList.remove('active');
        });
      }
    });
  }

  // Scroll functionaliteit - EENMALIG
  function setupScrollObserver() {
    function scrollToTarget() {
      var isMobile = window.innerWidth <= 767;

      if (isMobile) {
        var vaultActive = document.querySelector('.vault-active');
        if (!vaultActive) return;

        var headerOffset = 160;
        var position = vaultActive.getBoundingClientRect().top + window.pageYOffset;
        var scrollPosition = position - headerOffset;
      } else {
        var h1Element = document.querySelector('h1');
        if (!h1Element) return;

        var headerOffset = 110;
        var position = h1Element.getBoundingClientRect().top + window.pageYOffset;
        var scrollPosition = position - headerOffset;
      }

      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      });

      logDebug('Scroll uitgevoerd, device: ' + (isMobile ? 'mobiel' : 'desktop'));
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class' &&
          mutation.target.classList.contains('dropdown') &&
          mutation.target.classList.contains('active')
        ) {
          setTimeout(scrollToTarget, 50);
          break;
        }
      }
    });

    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    logDebug('Scroll observer geactiveerd');
  }

  // Initialisatie
  function init() {
    logDebug('=== Gecombineerd Bundle Selector gestart ===');
    
    detectProductCount();
    
    if (detectedProductCount === 0) {
      logDebug('Geen producten gevonden, script gestopt');
      return;
    }
    
    injectHTML();
    
    Promise.all([
      waitForElement('.bundle-container'),
      waitForElement('#simple-bundles-io-options select')
    ]).then(function () {
      logDebug('Benodigde elementen geladen, start initialisatie');

      setTimeout(() => {
        removeOutOfStockOptions();
        initializeSelects();
        parseFragrances();
        createSelectors();
        setupScrollObserver();
        logDebug(`=== Bundle Selector succesvol geïnitialiseerd voor ${detectedProductCount} producten ===`);
      }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();